module.exports = __webpack_public_path__ + "img/fwzt05_1.79e76be.png";